import api from "../../config/axiosConfig";

const GetUsers = async () => {
   const response = await api.get("/User");
   return response.data;
};

export default GetUsers;
